import { GzRmScannedIdentitiesWidgetWebComponent } from './component/GzRmScannedIdentitiesWidgetWebComponent';

export { GzRmScannedIdentitiesWidgetWebComponent };
